import React from "react";
import "./App.scss";
import "./pages/Branch.scss";
import {Navigate, Outlet, Route, Routes} from "react-router-dom";
import Roles from "./pages/admin/roles";
import Forms from "./pages/admin/forms";
import Branches from "./pages/admin/branches";
import FormCategories from "./pages/admin/formCategories";
import Users from "./pages/admin/users";
import AddForm from "./pages/admin/forms/AddForm";
import EditForm from "./pages/admin/forms/EditForm";
import AdminLayout from "./layouts/AdminLayout";
import Login from "./pages/Login";
import Secure from "./security/Secure";
import InternalUserLayout from "./layouts/InternalUserLayout";
import MyDesk from "./pages/internal_user/myDesk";
import History from "./pages/internal_user/History";
import PrivilegeAccess from "./pages/internal_user/PrivilegeAccess";
import ViewPrivilegeForm from "./forms/view/ViewPrivilege";
import AppLayout from "./layouts/AppLayout";
import AdminOnly from "./security/AdminOnly";
import ViewHistoryForm from "./forms/view/ViewHistoryForm";
import ViewHistory from "./forms/view/ViewHistory";
import { SidebarProvider } from "./contexts/Sidebarcontext";
import SignUp from "./pages/SignUp";

function App() {
    return (
        <SidebarProvider>
        <div className="App ">
            <Routes>
                <Route path={"login"} element={<Login/>}/>
                <Route path={"signUp"} element={<SignUp/>}/>
                <Route element={<AppLayout/>}>
                    <Route element={<Secure>
                        <InternalUserLayout/>
                    </Secure>}>
                        <Route index element={<Navigate to='my-desk'/>}/>
                        <Route path='my-desk' element={<MyDesk/>}/>
                        <Route path='my-history' element={<History/>}/>
                        <Route path='my-privilege' element={<><Outlet/></>}>
                            <Route index element={<PrivilegeAccess/>}/>
                        </Route>
                    </Route>

                    <Route path='deskForm'>
                        <Route path=':id' element={<Secure><ViewPrivilegeForm/> </Secure>}/>
                    </Route>

                    <Route path='historyForm'>
                        <Route path=':id' element={<Secure><ViewHistory/> </Secure>}/>
                    </Route>


                    <Route
                        path="dashboard"
                        element={<Secure>
                            <AdminOnly>
                            <AdminLayout/>
                            </AdminOnly>
                        </Secure>
                        }
                    >
                        <Route index element={<Navigate to="branches"/>}/>
                        <Route path="branches" element={<Branches/>}/>
                        <Route path="roles" element={<Roles/>}/>
                        <Route
                            path="forms"
                            element={
                                <>
                                    <Outlet/>
                                </>
                            }
                        >
                            <Route index element={<Forms/>}/>
                            <Route path="add" element={<AddForm/>}/>
                            <Route path=":id" element={<EditForm/>}/>
                        </Route>
                        <Route path="users" element={<Users/>}/>
                        <Route path="form-categories" element={<FormCategories/>}/>
                    </Route>
                </Route>
            </Routes>
        </div>
        </SidebarProvider>
    );
}

export default App;
